/**
 * 手机注册
 */
import React, { Component } from "react";
import loading from 'c-up-loading';
import notification from 'c-notification';
import PhoneLogin from './index';

class PhoneRegister extends Component{
	constructor(props){
		super(props);
		this.state = {
			progress: props.childProps.progress,
			childProps: props.childProps
		}
	}
	setInitState(state){
		this.refs.phoneLoginWrap.setInitState(state);
	}
	
	render(){
		return (
			<div className="pop-no-tab">
				<PhoneLogin userProcess="register" {...this.state.childProps} ref="phoneLoginWrap"/>
			</div>
		);
	}
}
module.exports = PhoneRegister;


// WEBPACK FOOTER //
// ./js/component/phone-login/phone-register.js